//配置信息
let url = location.protocol+'//'+location.hostname
const port = location.port
if(port){
	url += ':'+port
}
if(url.startsWith('localhost')){
	url = 'https://szxc-sociweb.yongqing.gov.cn:4443'
}
export default{
	webUrl:url+'/tusjf-cloud-gateway',
	staticUrl:url+'/tusjf-cloud-gateway/sys/common/static'
}
